import { NgModule, isDevMode } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HisUiService, HisGenericValueService } from 'hisng';

import { FinanceSharedModule } from './finance-shared.module';
import { FinanceRoutesModule } from './finance.routes';

import { BudgetSourceService } from 'app/fs/res/finance/service/budget-source/budget-source.service';
import { ResearchPartnerService } from 'app/fs/res/common/service/researchPartner/researchPartner.service';
import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';
import { ResearchContractService } from './service/research-contract/research-contract.service';
import { ProjectPeriodService } from './service/project/project-period.service';

/**
 * CoreModule for projects.
 */
@NgModule( {
    imports: [
        FinanceSharedModule,
        FinanceRoutesModule,
    ],
    declarations: [],
    exports: [
        FinanceSharedModule,
    ],
    providers: [
        /* common */
        HisUiService,
        HisGenericValueService,

        /* used in projects and budget-source*/
        BudgetSourceService,
        ResearchPartnerService,
        OrganizationService,
        ResearchContractService,
        ProjectPeriodService
    ],
} )

export class FinanceCoreModule {
}
